import { waitTillElementIsVisible } from '@/utils/waitTillElementIsVisible';

export default () => {
  return waitTillElementIsVisible('.MHeader');
};
